import mitt from 'mitt';

import { logger } from '@/utils/log';

export const emitter = mitt();

export const emit = (...params) => {
  logger.info('mitt emit', params);
  return emitter.emit(...params);
};

export const on = (...params) => {
  logger.info('mitt on', params);
  return emitter.on(...params);
};

export const EVENT_TYPES = {
  URL_CHANGE: 'url-change',
  PERSIST_UPDATE: 'persist-update',
  BOUGHT_PLANS_UPDATE: 'bought-plans-update',
  EMAIL_UPDATE: 'email-update',
  API_ERROR: 'api-error',
  POLLING_ERROR: 'polling-error',
  UI_MESSAGE: 'ui-message',
  UI_MESSAGE_CLICK_CLOSE: 'ui-message-click-close',
  UI_MESSAGE_CLICK_LINK: 'ui-message-click-link',
  UI_ALERT: 'ui-alert',
  ZVA_CLEAR_DATA: 'zva-clear-data',
  UI_GLOBAL_ALERT: 'ui-global-alert',
  UI_GLOBAL_ALERT_CLICK_CTA: 'ui-global-alert-click-cta',
};
